import { render, staticRenderFns } from "./ElementTitle.vue?vue&type=template&id=5f9bab82&scoped=true&"
import script from "./ElementTitle.vue?vue&type=script&lang=js&"
export * from "./ElementTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9bab82",
  null
  
)

export default component.exports